import makeAllOperators from './makeAllOperatorsNonImmutable';
import Annotation from './Annotation';
import BinMesh from './BinMesh';
import Camera from './Camera';
import Environment from './Environment';
import GeneralRenderer from './GeneralRenderer';
import Image from './Image';
import Light from './Light';
import Material from './Material';
import Pass from './Pass';
import Player from './Player';
import PolyMesh from './PolyMesh';
import Properties from './Properties';
import Renderer from './Renderer';
import Transform from './Transform';

const NoOp = { schema: {} };

const Bone = { Bone: NoOp };
const Null = { Null: NoOp };
const Mixer = { Action: NoOp, Mixer: NoOp };
Renderer['vray/create'] = NoOp;
const Timeline = { Timeline: NoOp };
const Viewport = { Viewport: NoOp };

const records = makeAllOperators({
  Annotation, BinMesh, Bone, Camera, Environment, GeneralRenderer, Light, Material,
  Mixer, Null, Pass, Player, PolyMesh, Properties,
  Renderer, Timeline, Transform, Image, Viewport,
}, { withNone: true });

export function lookupOperator(plugName, type, warnings) {
  const plug = records[plugName];
  if (!plug) {
    warnings.push(`Unknown plug: ${plugName}`);
    return records.None.NoOp;
  }

  const operator = plug[type];
  if (!operator) {
    warnings.push(`Unknown Operator: ${plugName}, ${type}`);
    return records.None.NoOp;
  }

  return operator;
}

export default records;



// WEBPACK FOOTER //
// ./src/operators/nonImmutable.js